<template>
  <DynamicModal
    :showModal="showModalProp"
    :persistent="false"
    @clickOutside="cancel"
    title="Deactivate Contracts"
    maxWidth="700px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="cancel"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" class="px-0">
            <v-card-text>The following contracts are about to be deactivated. Please set the end date before proceeding.</v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="pt-0">
            <SimpleDatePicker
              label="End Date"
              :value="endAt"
              :isRequired="true"
              :clearable="false"
              :readonly="false"
              :dense="false"
              :hideDetails="true"
              @selected-date-change="(newValue) => this.endAt = newValue"
            ></SimpleDatePicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              dense
              :headers="headers"
              :items="assignmentsToDeactivate"
            >
              <template v-slot:item.startAt="{ item }">
                {{ item.startAt | formatDate }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <v-row>
        <v-col cols="6">
          <v-btn
            color="primary"
            block
            @click="deactivateAssignments"
          >
            Deactivate
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
            block
            depressed
            outlined
            @click="cancel"
          >
            Back
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </DynamicModal>
</template>
<script>
import { mapActions } from 'vuex'
import DynamicModal from '@/components/dialogs/DynamicModal'
import { SimpleDatePicker } from '@/components/shared/datePickers'

export default {
  components: {
    DynamicModal,
    SimpleDatePicker
  },
  props: [
    'assignmentsToDeactivate'
  ],
  data () {
    return {
      showModalProp: false,
      endAt: new Date().toISOString(),
      headers: [
        { text: 'Client', value: 'clientName', width: '40%', cellClass: 'px-0 pl-3' },
        { text: 'Consultant', value: 'userFullName', width: '40%', cellClass: 'px-0 pl-2' },
        { text: 'Start Date', value: 'startAt', width: '20%', cellClass: 'px-0 pl-2' }
      ]
    }
  },
  methods: {
    ...mapActions('assignments', [
      'deactivateAssignmentInBulk'
    ]),
    async showModal () {
      this.showModalProp = true
    },
    closeModal () {
      this.showModalProp = false
    },
    cancel () {
      this.closeModal()
      this.$emit('cancel', this.id)
    },
    deactivateAssignments () {
      const payload = {
        endAt: this.endAt,
        assignmentIds: this.assignmentsToDeactivate.map(i => i.id)
      }
      this.deactivateAssignmentInBulk(payload)
        .then(() => {
          this.$emit('assignmentsDeactivated')
        })
        .finally(() => {
          this.showModalProp = false
        })
    }
  }
}
</script>
